import { FC } from 'react';
import { Link } from 'react-router-dom';
import { Center, CenterProps, Image } from '@chakra-ui/react';

import ChillImg from 'assets/brand/chill.png';
import Button from 'components/_core/Button';
import Text from 'components/_core/Text';

import * as routes from '../../../../routes';

interface NoMemberViewProps extends CenterProps {
  title: string;
  description?: string;
  ctaLabel: string;
}

const NoMemberView: FC<NoMemberViewProps> = ({
  ctaLabel,
  description,
  title,
  ...props
}) => (
  <Center flexDirection="column" {...props}>
    <Image marginBottom="space-16" src={ChillImg} width="144px" />

    <Text fontWeight="weight-500" size="lg" variant="primary">
      {title}
    </Text>

    {description ? <Text paddingTop="space-4">{description}</Text> : null}

    <Button
      as={Link}
      icon="plus"
      marginTop="space-32"
      to={routes.membersInvite}
    >
      {ctaLabel}
    </Button>
  </Center>
);

export default NoMemberView;
